<template>
  <div>
    <!--通知公告  -->
    <baseBreadcrumb :page="$t('message.Announcements')" :menu="$t('message.operationAndMaintenance')" />
    <!-- tabs -->
    <div class="tabs">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="站内信" name="1"></el-tab-pane>
        <el-tab-pane label="ChatWork" name="2" v-if="isAuth(595)"></el-tab-pane>
        <el-tab-pane label="rakuChat" name="3" v-if="isAuth(595)"></el-tab-pane>
        <el-tab-pane label="邮件" name="4" v-if="isAuth(595)"></el-tab-pane>
        <!-- <el-tab-pane label="rakuChat" name="3" v-if="isAuth(595)"></el-tab-pane> -->

      </el-tabs>
    </div>
    <div class="body" v-if="activeName == 1">
      <!-- 搜索 -->
      <div class="search">
        <!-- 开始时间 -->
        <div class="item">
          <el-date-picker v-model="datas.dateStart" type="datetime" :placeholder="$t('message.startDate')"
            default-time="00:00:00" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!-- 结束日期 -->
        <div class="item">
          <el-date-picker v-model="datas.dateEnd" type="datetime" :placeholder="$t('message.dateClosed')"
            default-time="23:59:59" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div class="item">
          <el-select v-model="datas.range" :placeholder="$t('message.allCustomers')">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <div class="item">
          <el-button type="primary" @click="noticeList">{{ $t("message.search") }}</el-button>
        </div>
        <!-- 发布通告 -->
        <div class="add">
          <router-link to="/announcement" target="_blank" v-if="isAuth(402)">
            <el-button type="success">
              {{ $t("message.alerts") }}
            </el-button>
          </router-link>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 收件人 -->
          <el-table-column align="center" :label="$t('message.recipients')" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.range == 10 || scope.row.range == 20 || scope.row.range == 30">
                {{ scope.row.range_name }}</span>
              <el-button type="text" v-else @click="getNoticePartClientAndAdmin(scope.row)">
                {{ scope.row.range_name }}
              </el-button>
            </template>
          </el-table-column>
          <!-- 标题 -->

          <el-table-column align="center" :label="$t('message.title')" width="300" prop="title">
            <template slot-scope="scope">
              {{ scope.row.title }}
              <span class="a-link" @click="look(scope.row)">

              </span>
            </template>
          </el-table-column>
          <!-- 内容 -->
          <el-table-column align="center" :label="$t('message.content')" prop="content">
            <template slot-scope="scope">
              <div v-html="scope.row.content" class="content"></div>
            </template>
          </el-table-column>
          <!-- 发送日期 -->
          <el-table-column align="center" :label="$t('message.sendTime')" width="200" prop="datetime_start">
          </el-table-column>
          <!-- 发送状态 -->
          <el-table-column align="center" :label="$t('message.sendingStatus')" width="100">
            <template slot-scope="scope">
              <span :style="{ color: new Date() > new Date(scope.row.datetime_start) ? '#67C23A' : 'red' }">
                {{ new Date() > new Date(scope.row.datetime_start) ? '发送完成' : '等待发送' }}</span>

            </template>
          </el-table-column>
          <!-- 开封数 -->
          <el-table-column align="center" :label="$t('message.openingCount')" width="100" prop="read_count">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="success" @click="redact(scope.row)">
                {{ $t("message.redact") }}
              </el-button>
              <el-button size="mini" type="primary" class="dark" @click="deleteNotice(scope.row.id)">
                {{ $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <ChatWork v-if="activeName == 2" />
    <rakuChat v-if="activeName == 3" />
    <email v-if="activeName == 4" />
    <!-- 查看全部 -->
    <preview ref="preview" :datas="item" />
    <!-- 人员列表 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px" center>
      <el-table :data="userData" border :header-cell-style="{ background: '#EDEFF4' }" max-height="500px">
        <!-- 客户ID -->
        <el-table-column prop="id" label="ID" align="center" width="100">
        </el-table-column>
        <!--客户名称-->
        <el-table-column prop="realname" label="客户名称/后台人员账号" align="center">
        </el-table-column>
      </el-table>

    </el-dialog>
    <!--  -->
    <el-dialog :close-on-click-modal="false" :visible.sync="editDialogVisible" width="1200px" center>
      <el-form :model="editData" :rules="rules" ref="datas" label-width="150px" class="demo-ruleForm">
        <!-- 通知标题 -->
        <el-form-item :label="$t('message.noticeTitle') + ':'" prop="title">
          <el-input v-model="editData.title" type="textarea"></el-input>
        </el-form-item>
        <!-- 通知内容 -->
        <el-form-item :label="$t('message.noticeContent') + ':'" prop="content">
          <quill-editor ref="myTextEditor" id="quill-editor" v-model="editData.content" :options="quillOption">
          </quill-editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="editDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="updateContent">
          {{ $t("message.save") }}
        </el-button>

      </span>
    </el-dialog>

  </div>
</template>
<script>
import preview from "./announcement/preview";
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ChatWork from './ChatWork/index'
import rakuChat from './rakuChat/index'
import email from './email/index'
export default {
  components: {
    preview,
    quillEditor,
    ChatWork,
    rakuChat,
    email,
  },
  data() {
    return {
      activeName: '1',

      quillOption: quillConfig,
      editDialogVisible: false,
      dialogVisible: false,
      datas: {
        range: "",
        dateStart: "",
        dateEnd: "",
        pageSize: 100
      },
      total: 0,
      options: [
        {
          label: "全部客户-代购",
          value: "10",
        },
        {
          label: "部分客户-代购",
          value: "11",
        },
        {
          label: "全部管理员",
          value: "20",
        },
        {
          label: "部分管理员",
          value: "21",
        },
        {
          label: "全部客户-SASS",
          value: "30",
        },
        {
          label: "部分客户-SASS",
          value: "31",
        },
      ],
      tableData: [],
      item: {},
      userData: [],
      editData: {},
      rules: {
        title: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],

      },
    };
  },
  created() {
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName
    }
    this.noticeList();
  },
  methods: {

    noticeList() {
      this.$api.siteConfiguration.noticeList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total
      });
    },
    //查看
    look(item) {
      this.item = item;
      this.$refs.preview.dialogVisible = true;
    },
    //部分用户列表
    getNoticePartClientAndAdmin(item) {
      this.$api.siteConfiguration.getNoticePartClientAndAdmin({ notice_id: item.id }).then((res) => {
        this.userData = res.data
        this.dialogVisible = true
      });

    },
    //批量删除通知
    deleteNotice(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.noticeApi.deleteNotice({ id }).then(res => {
            this.$message.success(res.msg)
            this.noticeList()
          })
        })
        .catch(() => { });
    },
    //编辑
    redact(item) {
      this.editData = JSON.parse(JSON.stringify(item))
      this.editDialogVisible = true
    },
    //仅修改标题和内容
    updateContent() {
      this.$refs.datas.validate(valid => {
        if (valid) {
          this.$api.noticeApi.updateContent(this.editData).then(res => {
            this.$message.success(res.msg)
            this.noticeList()
            this.editDialogVisible = false
          })
        }
      })

    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.noticeList();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.noticeList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  flex-wrap: wrap;

  .item {
    width: 240px;
  }

  .add {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.table {
  margin: 20px 0;
}

.content {
  max-height: 100px;
  overflow-y: auto;
}

/deep/.ql-editor {
  height: 300px !important;
}
</style>